<template>
  <div>
    <div class="list-box" v-loading="loading">
      <div class="item" v-for="(item,index) in list" :key="index" >
        <div class="left" @click="toOrg(item.organization_user_id)">
          <h3 >{{item.foreign_name ? item.foreign_name : item.organization_name}}</h3>
          <p>{{item.organization_type_cn}} <span>|</span> {{item.scale_cn}}</p>
        </div>
        <div class="center" @click="toOrg(item.organization_user_id)">
          <span >{{item.jobsCount}}个在招职位</span>
        </div>
        <div class="right">
          <span @click="delAttention(item.organization_user_id)"><i class="iconfont iconxingxing"></i>取消关注</span>
        </div>
      </div>
      <no-data v-if="noData"/>
    </div>
    <div v-if="list.length>0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="Number(pageNum)"
        :page-size="pageSize"
        :prev-text="pageText.prevText"
        :next-text="pageText.nextText"
        layout="prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>

  </div>
</template>

<script>
  import noData from '../../components/noData'
  export default {
    data() {
      return {
        list: [],  //职位列表
        pageNum:1,
        pageSize: 10,
        pageTotal: 1,
        pageText: {
          prevText: '<上一页',
          nextText: '下一页>'
        },
        noData: false,
        loading: true
      }
    },
    computed: {},
    created() {
      this.$emit('setType', 3)
      this.init()
    },
    methods: {
      //  获取数据
      init(){
        this.loading = true
        if(this.$route.query.pageNum){
          this.pageNum = this.$route.query.pageNum
        }else {
          this.pageNum = 1
        }
        this.$api.apiMember.userAttention({
          userToken:this.$store.state.user.user_token,
          page:this.pageNum,
          pageSize:this.pageSize
        }).then(res=>{
          this.noData = false
          this.list = res.data
          this.loading = false
          this.pageTotal = res.total_number
        }).catch(() =>{
          this.list = []
          this.noData = true
          this.loading = false
        })
      },
      // 去机构
      toOrg(id){
        this.$router.push('/home/orgDetails/'+id)
      },
      // 取消关注
      delAttention(id){
        this.$confirm('您确定要取消关注吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiMember.delAttention({
            userToken:this.$store.state.user.user_token,
            organizationId:id,
            type:2
          }).then(()=>{
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            if(this.list.length>1 || this.pageNum === 1){
              this.init()
            }else{
              this.pageNum = this.pageNum -1
            }
          }).catch()
        }).catch();
      },
      // 分页
      handleSizeChange(val) {
        this.pageNum = val
      },
      handleCurrentChange(val) {
        this.pageNum = val
      },
      // 改变路径
      setPath(val){
        this.$router.push({
          path: '/home/user/follow',
          query: {
            pageNum:val
          }
        })
      }
    },
    watch:{
      pageNum() {
        this.setPath(this.pageNum)
      },
      '$route': 'init'
    },
    components: {
      noData,
    }
  }
</script>

<style scoped lang="scss">
  .list-box{
    background: #fff;
    .item{
      display: flex;
      align-items: center;
      padding: 30px;
      border-bottom: 1px solid #f2f3f5;
      cursor: pointer;
      .left{
        width: 540px;
        h3{
          line-height: 30px;
          margin-bottom: 10px;
          font-size: 18px;
        }
        p{
          line-height: 24px;
          color: #999;
          span{
            padding: 0 10px;
          }
        }
      }
      .center{
        width: 300px;
        text-align: center;
        span{
          font-size: 16px;
          color: #ffb32f;
          cursor: pointer;
        }
      }
      .right{
        width: 300px;
        text-align: center;
        span{
          font-size: 16px;
          color: #00a2ea;
          cursor: pointer;
          i{
            padding-right: 5px;
          }
        }
      }
    }
  }
</style>
